import React from 'react';

import { reverse, sortBy } from 'lodash';

import usePageTitle from '../../../utils/hooks/use_page_title';

import { getModelActivityData } from '../../ActivityLog/activity-utils';

import ActivityLog from '../../ActivityLog/ActivityLog';
import ErrorSlate from '../../ErrorSlate/ErrorSlate';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ModelsList from './ModelsList';
import PageLayout from '../../pages/PageLayout';
import PrimaryContent from '../../pages/layouts/PrimaryContent';
import SearchInput from '../../common/TextInputs/SearchInput/SearchInput';
import SecondaryContent from '../../pages/layouts/SecondaryContent';

import { getCommentsWithModels } from '../../../utils/product_utils';
import { ModelSearchProvider, useModelSearch } from '../ModelSearchContext';
import { ReadOnlyModelCommentsProvider, useCommentContext } from '../../contexts/CommentData/CommentData';
import { useClientContext } from '../../contexts/ClientData/ClientData';
import { useUserContext } from '../../contexts/UserData/UserData';

export const ModelListView = ({
  models,
  isLoading,
  hasSearchQueryError,
}) => (
  <div className="mt-2 bg-white border border-border-dark rounded relative">
    {
      isLoading ? (
        <LoadingSpinner animationKey="model-list-spinner" size="medium" useOverlay />
      ) : null
    }
    {
      hasSearchQueryError ? (
        <ErrorSlate
          errorText="Something went wrong loading your models"
        />
      ) : (
        <ModelsList models={models} />
      )
    }
  </div>
)

const ModelSearchPanel = () => {
  const {
    loading, error, models, searchQuery, setSearchQuery
  } = useModelSearch();

  return (
    <PrimaryContent>
      <SearchInput
        className="relative w-full border border-border-dark rounded py-2 pl-10 bg-white"
        ariaLabel="Search by model name or tag"
        placeholder="Search by model name or tag"
        value={searchQuery}
        onChange={event => setSearchQuery(event.target.value)}
      />
      <ModelListView
        models={models}
        isLoading={loading}
        hasSearchQueryError={error}
      />
    </PrimaryContent>
  )
}

const ActivityLogWrapper = () => {
  const { isAuthEnabled } = useClientContext();
  const { userData } = useUserContext();
  const { comments: commentsWithUsers, error, loading } = useCommentContext();
  const { models = [] } = useModelSearch();

  if (!isAuthEnabled) {
    return null;
  }

  const activityData = getModelActivityData({
    comments: getCommentsWithModels(models, commentsWithUsers),
    currentUser: userData,
  });
  return (
    <SecondaryContent>
      <ActivityLog
        id="model-search-activity-log"
        height={480}
        activityData={activityData}
        commentError={error}
        areCommentsLoading={loading}
      />
    </SecondaryContent>
  )
}

export const ModelsIndex = () => {
  usePageTitle('Models | Wallaroo');

  return (
    <PageLayout>
      <ModelSearchProvider>
        <ModelSearchPanel />
        <ReadOnlyModelCommentsProvider>
          <ActivityLogWrapper />
        </ReadOnlyModelCommentsProvider>
      </ModelSearchProvider>
    </PageLayout>
  );
};
export default ModelsIndex;
